// cityAliases.js - Städte-Aliase für verschiedene Schreibweisen

const cityAliases = {
  // Beispiele für verschiedene Schreibweisen
  'Köln': 'Cologne',
  'Cologne': 'Köln',
  'München': 'Munich',
  'Munich': 'München',
  'Nürnberg': 'Nuremberg',
  'Nuremberg': 'Nürnberg',
  // Weitere Aliase können hier ergänzt werden
};

// Normalisiert Städtenamen
export const normalizeCityName = (cityName) => {
  if (!cityName) return '';
  
  // Prüfe ob es einen Alias gibt
  if (cityAliases[cityName]) {
    return cityAliases[cityName];
  }
  
  // Ansonsten Original zurückgeben
  return cityName;
};

export default cityAliases;